const isLahainaUser = window.location.toString().includes('lahaina')
const isMauiCountyUser = window.location.toString().includes('mauicounty')

export const staticStrings = {
    rates24: isLahainaUser || isMauiCountyUser ? 'Rates subject to change' : 'Rates to start soon',
}
